<template>
  <div>
    <Organization :v="v" />

    <OrganizationTrustee
      :v="v.trustee"
      label="Сведения о представителе юридического лица"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import Organization, {
  organizationModel,
  organizationValidation,
  prefillEsiaOrg,
} from '@/components/services/EgrnConfirm/Applicant/components/Organization';
import OrganizationTrustee, {
  organizationTrusteeModel,
  getOrganizationTrusteeValidation,
  prefillEsiaOrgTrustee,
} from '@/components/services/EgrnConfirm/Applicant/components/OrganizationTrustee';

export const mrpaEnableTrusteeOrganizationModel = {
  ...cloneDeep(organizationModel),
  trustee: cloneDeep(organizationTrusteeModel),
};

export const getMrpaEnableTrusteeOrganizationValidation = (organization) => {
  return {
    ...organizationValidation,
    trustee: getOrganizationTrusteeValidation(organization.trustee),
  };
};

export const prefillEsiaMrpaEnableTrusteeOrganization = async () => {
  const esiaOrg = await prefillEsiaOrg();

  return cloneDeep({
    ...mrpaEnableTrusteeOrganizationModel,
    ...esiaOrg,
    trustee: await prefillEsiaOrgTrustee(),
  });
};

export default {
  name: 'MrpaEnableTrusteeOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    OrganizationTrustee,
    Organization,
  },
};
</script>
